import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
const generateStyle = componentTheme => {
  const commonStyles = {
    background: 'none',
    backgroundColor: componentTheme.backgroundColor,
    width: '100%',
    border: 'none',
    height: '1rem',
    borderRadius: 0
  };
  return {
    meter: _objectSpread(_objectSpread({
      label: 'progress',
      display: 'block',
      boxSizing: 'border-box',
      appearance: 'none',
      MozAppearance: 'meter',
      WebkitAppearance: 'meter'
    }, commonStyles), {}, {
      '&::-webkit-meter-bar': _objectSpread({}, commonStyles),
      '&::-webkit-meter-optimum-value': {
        backgroundImage: `linear-gradient(to right, ${componentTheme.meterColorStart} 0%, ${componentTheme.meterColorEnd} 100%)`
      },
      '&::-webkit-meter-suboptimum-value': {
        backgroundImage: `linear-gradient(to right, ${componentTheme.meterColorStart} 0%, ${componentTheme.meterColorEnd} 100%)`
      },
      '&::-webkit-meter-even-less-good-value': {
        backgroundImage: `linear-gradient(to right, ${componentTheme.meterColorStart} 0%, ${componentTheme.meterColorEnd} 100%)`
      },
      '&::-moz-meter-bar': {
        backgroundColor: componentTheme.backgroundColor
      },
      '&:-moz-meter-optimum::-moz-meter-bar': {
        backgroundImage: `linear-gradient(to right, ${componentTheme.meterColorStart} 0%, ${componentTheme.meterColorEnd} 100%)`
      },
      '&:-moz-meter-sub-optimum::-moz-meter-bar': {
        backgroundImage: `linear-gradient(to right, ${componentTheme.meterColorStart} 0%, ${componentTheme.meterColorEnd} 100%)`
      },
      '&:-moz-meter-sub-sub-optimum::-moz-meter-bar': {
        backgroundImage: `linear-gradient(to right, ${componentTheme.meterColorStart} 0%, ${componentTheme.meterColorEnd} 100%)`
      }
    })
  };
};
export default generateStyle;